import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {GoogleAnalyticsService} from '../../../core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';

import * as fromRoot from '../../../reducers/index';
import * as fromAfbApi from '../../../afb-api/reducers/index';
import * as fromAfbGraphqlApi from '../../../afb-graphql-api/reducers/index';
import {filter, skip} from 'rxjs/operators';
import {SelectOrganization} from '../../../core/actions/core.actions';
import {GetOrganizationTokens} from '../../../afb-api/actions/organization-token.actions';
import {MatDialogRef} from '@angular/material';
import {withLatestFrom} from 'rxjs/internal/operators';
import {GetOrganizations} from '../../../afb-graphql-api/actions/organization.actions';
import {Organization} from '../../../afb-graphql-api/models/organization';

@Component({
  selector: 'awair-organization-list-dialog',
  templateUrl: './organization-list-dialog.container.html',
  styleUrls: ['./organization-list-dialog.container.scss']
})

export class OrganizationListDialogContainer implements OnInit {

  accessToken$: Observable<string> = this.afbApiStore.pipe(
    select(fromAfbGraphqlApi.accessToken),
    filter((accessToken: string) => accessToken != null)
  );

  // Organizations are preloaded in the guard
  activatedOrganizations$: Observable<Organization[]> = this.afbGraphqlApi.pipe(
    select(fromAfbGraphqlApi.activatedOrganizations)
  );
  deactivatedOrganizations$: Observable<Organization[]> = this.afbGraphqlApi.pipe(
    select(fromAfbGraphqlApi.deactivatedOrganizations)
  );
  pendingOrganizations$: Observable<Organization[]> = this.afbGraphqlApi.pipe(
    select(fromAfbGraphqlApi.pendingOrganizations)
  );

  isGetOrganizationsLoading$: Observable<boolean> = this.afbGraphqlApi.pipe(
    select(fromAfbGraphqlApi.isGetOrganizationsLoading)
  );
  isGetOrganizationTokensLoaded$: Observable<boolean> = this.afbApiStore.pipe(
    select(fromAfbApi.isGetOrganizationTokenLoaded),
    skip(1)
  );

  isEnteringOrganization: boolean = false;

  constructor(private myDialogRef: MatDialogRef<OrganizationListDialogContainer>,
              private rootStore: Store<fromRoot.State>,
              private afbApiStore: Store<fromAfbApi.State>,
              private afbGraphqlApi: Store<fromAfbGraphqlApi.State>,
              private googleAnalyticsService: GoogleAnalyticsService,
              private router: Router) {
  }

  ngOnInit() {
    // Update organizations since this component doesn't come after organization-list guard
    this.accessToken$.subscribe((accessToken: string) => {
      this.afbApiStore.dispatch(new GetOrganizations({accessToken}));
    });
  }

  onCancel(): void {
    this.myDialogRef.close();
  }

  onCreateOrganization(): void {
    this.router.navigate(['/org/new']);
    this.myDialogRef.close();
  }

  onEnterOrganization(selectedOrganization: Organization, accessToken: string): void {
    this.isEnteringOrganization = true;

    this.afbApiStore.dispatch(new GetOrganizationTokens({
      accessToken,
      organizationIds: [selectedOrganization.id]
    }));

    // Subscribing here to access selectedOrganization
    this.isGetOrganizationTokensLoaded$.pipe(
      withLatestFrom(of(selectedOrganization))
    ).subscribe(([isGetOrganizationTokensLoaded, _selectedOrganization]: [boolean, Organization]) =>
        this.navigateToSelectedOrganization(isGetOrganizationTokensLoaded, _selectedOrganization));
  }

  private navigateToSelectedOrganization(isGetOrganizationTokensLoaded: boolean, selectedOrganization: Organization): void {
    if (isGetOrganizationTokensLoaded) {
      this.rootStore.dispatch(new SelectOrganization({organizationId: selectedOrganization.id}));

      const role = selectedOrganization.role;
      this.googleAnalyticsService.emitEvent('Role', 'enter - org', (`${role.charAt(0).toUpperCase()}${role.slice(1)}`));

      window.location.reload();
    }
  }
}
